import { gql } from '@apollo/client';

export const DELETE_USER = gql`
  mutation deleteUser($user_idx_list: [Int!]!) {
    deleteUser(user_idx_list: $user_idx_list)
  }
`;
